import { Object3D, PerspectiveCamera, Vector3, Box3 } from 'three';
import { OrbitControls } from 'three-stdlib';
import { ITuple3 } from '../component-data-structure';

const size = new Vector3();
const center = new Vector3();
const box = new Box3();

export const fitCameraToObjects = (camera: PerspectiveCamera, controls: OrbitControls, selection: Object3D[], fitOffset = 1.2, positionSubVectorOverride?: ITuple3): void => {
	if (!controls) return;
	box.makeEmpty();

	const [object] = selection;
	box.setFromObject(object);

	for (const object of selection) {
		box.expandByObject(object);
	}

	box.getSize(size);
	box.getCenter(center);

	const maxSize = Math.max(size.x, size.y, size.z);
	const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * camera.fov) / 360));
	const fitWidthDistance = fitHeightDistance / camera.aspect;
	const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance);
	const positionSubVector = positionSubVectorOverride ? new Vector3(...positionSubVectorOverride) : camera.position;
	const direction = controls.target.clone().sub(positionSubVector).normalize().multiplyScalar(distance);

	controls.maxDistance = distance * 10;
	controls.target.copy(center);

	camera.near = distance / 100;
	camera.far = distance * 100;
	camera.updateProjectionMatrix();

	camera.position.copy(controls.target).sub(direction);
	controls.update();
};
